// extracted by mini-css-extract-plugin
export default {"liked":"style_liked__MJW8m"};